<template>
  <div>
    <DropMenuBtn @click="handleClick" ref="profileMenu" />
    <DropMenuContent v-if="isOpen" @close="handleMenuContent" />
  </div>
</template>

<script>
import { useUtil } from '@/plugins/util'
import { usePhysicianStore } from '@/store/pinia/physician'
import DropMenuBtn from './partials/DropMenuBtn.vue'
import DropMenuContent from './partials/DropMenuContent.vue'
import * as amplitude from '@amplitude/analytics-browser'

export default {
  components: { DropMenuBtn, DropMenuContent },
  data() {
    return {
      isOpen: false,
    }
  },
  methods: {
    handleClick(menuIsOpen) {
      const util = useUtil()
      const physicianStore = usePhysicianStore()

      const userData = util.prepareAnalyticsUserProperties(physicianStore)
      amplitude.track('Clique no header', {
        button: 'avatar',
        buttonTitle: 'Avatar',
        ...userData,
      })
      this.isOpen = menuIsOpen
    },
    handleMenuContent(state) {
      this.isOpen = state
      this.$refs.profileMenu.setOpenState(state)
    },
  },
}
</script>

<style scoped></style>
